var _path, _mask, _g, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgVisitBuilding = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 48,
  height: 46,
  viewBox: "0 0 48 46",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M24 45.1948C37.2548 45.1948 48 35.0776 48 22.5974C48 10.1172 37.2548 0 24 0C10.7452 0 0 10.1172 0 22.5974C0 35.0776 10.7452 45.1948 24 45.1948Z",
  fill: "#BCD9C9"
})), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
  id: "mask0",
  "mask-type": "alpha",
  maskUnits: "userSpaceOnUse",
  x: 0,
  y: 0,
  width: 48,
  height: 46
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M24 45.1948C37.2548 45.1948 48 35.0776 48 22.5974C48 10.1172 37.2548 0 24 0C10.7452 0 0 10.1172 0 22.5974C0 35.0776 10.7452 45.1948 24 45.1948Z",
  fill: "white"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask0)"
}, /*#__PURE__*/React.createElement("rect", {
  x: 7.71423,
  y: 16.9481,
  width: 31.7143,
  height: 36.9776,
  rx: 3,
  fill: "#F1F6F4"
}), /*#__PURE__*/React.createElement("rect", {
  x: 6.75,
  y: 16.084,
  width: 34.5,
  height: 29.975,
  rx: 3.25,
  stroke: "#727D79",
  strokeWidth: 1.5
}), /*#__PURE__*/React.createElement("rect", {
  x: 24,
  y: 25.0184,
  width: 12.8571,
  height: 1.6141,
  rx: 0.80705,
  fill: "#999E9C"
}), /*#__PURE__*/React.createElement("rect", {
  x: 24,
  y: 29.0537,
  width: 12.8571,
  height: 1.6141,
  rx: 0.80705,
  fill: "#999E9C"
}), /*#__PURE__*/React.createElement("rect", {
  x: 28.2858,
  y: 33.0891,
  width: 8.57143,
  height: 1.6141,
  rx: 0.807049,
  fill: "#999E9C"
}))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M9.875 34.7339V24.7339C9.875 24.0464 10.4319 23.4839 11.1264 23.4839H19.8861C20.5744 23.4839 21.125 24.0464 21.125 24.7339V34.7339C21.125 35.4214 20.5744 35.9839 19.8861 35.9839H17.3771V34.7339H19.2674C19.6126 34.7339 19.8924 34.4541 19.8924 34.1089V25.3589C19.8924 25.0137 19.6126 24.7339 19.2674 24.7339H11.7389C11.3937 24.7339 11.1139 25.0137 11.1139 25.3589V34.1089C11.1139 34.4541 11.3937 34.7339 11.7389 34.7339H13.6229V35.9839H11.1264C10.4381 35.9839 9.875 35.4214 9.875 34.7339Z",
  fill: "#FF8B22"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M14.25 31.6089C13.9048 31.6089 13.625 31.8887 13.625 32.2339V35.9839H17.375V32.2339C17.375 31.8887 17.0952 31.6089 16.75 31.6089H14.25Z",
  fill: "#FF8B22"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  d: "M13 25.9839H14.25V27.2339H13V25.9839Z",
  fill: "#FF8B22"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  d: "M18 25.9839H16.75V27.2339H18V25.9839Z",
  fill: "#FF8B22"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  d: "M13 29.1089H14.25V30.3589H13V29.1089Z",
  fill: "#FF8B22"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  d: "M18 29.1089H16.75V30.3589H18V29.1089Z",
  fill: "#FF8B22"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgVisitBuilding);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/visitBuilding.5f2479bf52b3e9436524cee7d051a5ad.svg";